import Loader from '@src/components/_shared/UI/Loader';

type PDFViewerProps = {
    name: string;
    setIsLoading: (isLoading: boolean) => void;
    url: string;
    isLoading?: boolean;
}

const PDFViewer: React.FC<PDFViewerProps> = ({name, setIsLoading, url, isLoading = true}) => {
    return (
        <>
            {isLoading && (
                <div style={{ display: 'flex', justifyContent: 'center', padding: '20px' }}>
                    <Loader type="SMALL_SPINNER" />
                </div>
            )}
            <iframe
                src={url}
                width="769px"
                height="529px"
                title={name}
                style={{ 
                    border: 'none',
                    display: isLoading ? 'none' : 'block'
                }}
                onLoad={() => setIsLoading(false)}
            />
        </>
    );
}

export default PDFViewer;
